import { render, staticRenderFns } from "./InfoModal.vue?vue&type=template&id=2de24915&scoped=true"
import script from "./InfoModal.vue?vue&type=script&lang=ts"
export * from "./InfoModal.vue?vue&type=script&lang=ts"
import style0 from "./InfoModal.vue?vue&type=style&index=0&id=2de24915&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2de24915",
  null
  
)

export default component.exports